import { render, staticRenderFns } from "./LeadAdd.vue?vue&type=template&id=d0a394ac&"
import script from "./LeadAdd.vue?vue&type=script&lang=js&"
export * from "./LeadAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports